// For more info about these commands
// https://eurostarwiki.atlassian.net/wiki/spaces/HOR/pages/1540980892/Card+Receipt+Printing
export const PRINTER_PECTABS_PRINT_COMMAND =
  'PT#;?ZR11A#@;#TICK#>>/#BOARD#01031117D#0216A01F#0326A26F#0405C01#0508C07#0605C17#0705C23#0808E01#0905E09#1003E15#1105G01#1232G08#1304G43#1420G47#1507H01#1619H09#1750L01#1804H43#1909H47#2010I01#2109I13#2204I43#2322I47#2414J43#2502J59#2607K01#2712K13#2830N01#2917N53#3050O01#3117O53#3212P53#3332R20#';
